export default "__VITE_ASSET__uTr8ThBQ__"